import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getCalificacionTotal'
})
export class GetCalificacionTotalPipe implements PipeTransform {

  transform(id_user:any, todos_curos: any): any {
    let totalCalificacion:any=0;
    let contador:any=0;
    if(todos_curos && todos_curos.length>0){
      todos_curos.forEach(element => {
        if(element.calificacion && element.calificacion.length>0){
          const user = element.calificacion.find(x=> x.id_user == id_user);
          if(user){
            totalCalificacion += user.totalCalificacion;
          }
        }
        contador++;
      });
    }
    return (totalCalificacion/contador).toFixed(2);
  }

}
